<template>
  <div>
    <br />
    <b>Programs</b>: {{ renderer.programs }}
    <b>Geometries</b>: {{ renderer.geometries }}
    <b>Textures</b>: {{ renderer.textures }}
    <b>Drawcalls</b>: {{ renderer.drawcalls }}
    <b>Triangles</b>: {{ renderer.triangles }} <br />

    <b>Frame Time</b>: {{ frameTime }} <b>Frame Time Average</b>: {{ frameTimeAverage.toFixed(1) }}<br />
    <b>FPS</b>: {{ Math.ceil(1000 / frameTimeAverage) }}<br /><br />
  </div>
</template>

<script>
import { renderLevels } from '@/assets/data'
import { levelFPS } from '@/utils/LevelFPS'
import { webGL } from '@/webGL/WebGL'

export default {
  data () {
    return {
      frameTime: 0,
      frameTimeAverage: 0,
      currentLevel: 0,
      levels: renderLevels,
      renderer: {
        programs: webGL.renderer.renderer.info.programs.length,
        geometries: webGL.renderer.renderer.info.memory.geometries,
        textures: webGL.renderer.renderer.info.memory.textures,
        drawcalls: webGL.renderer.renderer.info.render.calls,
        triangles: webGL.renderer.renderer.info.render.triangles
      }
    }
  },

  methods: {
    onUpdate ({ delta }) {
      this.frameTime = delta
      this.frameTimeAverage = levelFPS.average
      this.currentLevel = levelFPS.level

      this.renderer.programs = webGL.renderer.renderer.info.programs.length
      this.renderer.geometries = webGL.renderer.renderer.info.memory.geometries
      this.renderer.textures = webGL.renderer.renderer.info.memory.textures
      this.renderer.drawcalls = webGL.renderer.renderer.info.render.calls
      this.renderer.triangles = webGL.renderer.renderer.info.render.triangles
    },

    onLevel (level) {
      levelFPS.level = level
    }
  }
}
</script>